import React from "react";
import { motion } from "framer-motion";
import { Send, Rocket } from "lucide-react";
import { PROJECT, ASSETS } from "../lib/constants";
import { Countdown } from "./Countdown";

export const Hero = () => {
    return (
        <section
            id="hero"
            data-testid="hero-section"
            className="relative pt-28 pb-20 sm:pt-32 sm:pb-28 overflow-hidden scanlines"
        >
            {/* Backdrop blobs */}
            <div className="absolute -top-32 -left-20 w-[400px] h-[400px] rounded-full blur-[120px] opacity-30 bg-pink-brand pointer-events-none" />
            <div className="absolute top-40 -right-32 w-[450px] h-[450px] rounded-full blur-[140px] opacity-20 bg-yellow-brand pointer-events-none" />

            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
                    <div className="lg:col-span-7">
                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6 }}
                            className="inline-flex items-center gap-2 border border-pink-brand px-3 py-1 mb-6"
                        >
                            <span className="w-2 h-2 rounded-full bg-pink-brand animate-pulse" />
                            <span className="font-mono-soft text-xs uppercase tracking-[0.25em] text-pink-brand">
                                Phase 3 / Active
                            </span>
                        </motion.div>

                        <motion.h1
                            initial={{ opacity: 0, y: 30 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.7, delay: 0.1 }}
                            className="font-display text-6xl sm:text-7xl md:text-8xl lg:text-[9rem] leading-[0.85] uppercase"
                        >
                            <span className="block text-white">LE</span>
                            <span className="block text-pink-brand">BON</span>
                            <span className="block text-yellow-brand">BON</span>
                        </motion.h1>

                        <motion.p
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.8, delay: 0.3 }}
                            className="mt-6 text-xl sm:text-2xl text-white/80 max-w-xl italic"
                        >
                            "{PROJECT.tagline}."
                        </motion.p>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.4 }}
                            className="mt-4 flex flex-wrap items-center gap-4"
                        >
                            <span className="font-mono-soft text-sm text-yellow-brand uppercase tracking-widest">
                                Ticker: {PROJECT.ticker}
                            </span>
                            <span className="text-[#a19d9a]">·</span>
                            <span className="font-mono-soft text-sm text-pink-brand uppercase tracking-widest">
                                Launching on {PROJECT.platform}
                            </span>
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1 }}
                            transition={{ duration: 0.6, delay: 0.6 }}
                            className="mt-10"
                        >
                            <div className="font-mono-soft text-xs uppercase tracking-[0.3em] text-[#a19d9a] mb-4">
                                Launch in →
                            </div>
                            <Countdown target={PROJECT.launchDateISO} />
                        </motion.div>

                        <motion.div
                            initial={{ opacity: 0, y: 20 }}
                            animate={{ opacity: 1, y: 0 }}
                            transition={{ duration: 0.6, delay: 0.8 }}
                            className="mt-10 flex flex-wrap gap-4"
                        >
                            <a
                                href={PROJECT.telegram}
                                target="_blank"
                                rel="noreferrer"
                                data-testid="hero-telegram-btn"
                                className="inline-flex items-center gap-2 bg-pink-brand text-white px-6 py-4 font-bold uppercase tracking-wider hover:bg-yellow-brand hover:text-[#0a0806] transition-colors brutal-shadow-yellow"
                            >
                                <Send className="w-5 h-5" />
                                Join Telegram
                            </a>
                            <a
                                href="#how-to-buy"
                                data-testid="hero-how-to-buy-btn"
                                className="inline-flex items-center gap-2 bg-transparent border-2 border-yellow-brand text-yellow-brand px-6 py-4 font-bold uppercase tracking-wider hover:bg-yellow-brand hover:text-[#0a0806] transition-colors"
                            >
                                <Rocket className="w-5 h-5" />
                                How to Buy
                            </a>
                        </motion.div>
                    </div>

                    {/* Hero image */}
                    <div className="lg:col-span-5 relative">
                        <motion.div
                            initial={{ opacity: 0, scale: 0.8, rotate: -8 }}
                            animate={{ opacity: 1, scale: 1, rotate: -3 }}
                            transition={{ duration: 1, delay: 0.3 }}
                            className="relative"
                        >
                            <div className="relative animate-float">
                                <div className="absolute -inset-6 bg-pink-brand opacity-30 blur-3xl pointer-events-none" />
                                <div className="relative border-4 border-yellow-brand bg-[#14110f] p-3 brutal-shadow-pink">
                                    <img
                                        src={ASSETS.heroMeme}
                                        alt="LeBron holding lil cup"
                                        data-testid="hero-meme-img"
                                        className="w-full max-w-md mx-auto block"
                                    />
                                </div>
                                <div className="absolute -bottom-4 -right-4 bg-pink-brand text-white px-4 py-2 font-display text-2xl uppercase rotate-3">
                                    THE CUP
                                </div>
                                <div className="absolute -top-4 -left-4 bg-yellow-brand text-[#0a0806] px-3 py-1 font-mono-soft text-xs uppercase -rotate-6 font-bold">
                                    $LBRON
                                </div>
                            </div>
                        </motion.div>
                    </div>
                </div>
            </div>
        </section>
    );
};
